import React from "react";
import PropTypes from "prop-types";
const UploadIcon = ({ color = "#2F39D3" }) => {
  return (
    <svg
      width="17"
      height="19"
      viewBox="0 0 17 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.7608 10.4859L10.0924 16.1543C8.21402 18.0327 5.1686 18.0327 3.29024 16.1543C1.41187 14.2759 1.41187 11.2305 3.29024 9.35216L9.93043 2.71196C11.1827 1.45972 13.213 1.45972 14.4652 2.71196C15.7174 3.96421 15.7174 5.99449 14.4652 7.24673L7.825 13.8869C7.19888 14.513 6.18374 14.513 5.55762 13.8869C4.9315 13.2608 4.9315 12.2457 5.55762 11.6195L12.1978 4.97935"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};
UploadIcon.propTypes = {
  color: PropTypes.string,
};
export default UploadIcon;
